export default __webpack_public_path__ + "static/media/witbookingAI_Desktop.a5dca650.png";